export default {"src":"/_next/static/media/facebook.6365d6ec.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};